import AjaxUtil from 'common/Js/AjaxHelper/AjaxUtil';
import { ApiEndPoints } from 'common/ApiHelper/ApiUrls';

const defaultOptions = {
  times: 3,
  initialDelayTime: 100,
  onRetry: null,
  shouldRetry: null
};

const retryOptions = {
  executed: 0,
  currentDelay: null
};

const createOptions = userOptions => ({
  ...defaultOptions,
  ...retryOptions,
  ...userOptions
});

const calcNextRetryDelay = currentDelay => currentDelay * 2;

const createOptionsForNextRetry = options => {
  const { currentDelay, initialDelayTime, executed } = options;
  return {
    ...options,
    executed: executed + 1,
    currentDelay: currentDelay ? calcNextRetryDelay(currentDelay) : initialDelayTime
  };
};

const shouldRetryByExecutedTimes = ({ executed, times }) => executed < times;

const delay = delayTime => new Promise(resolve => setTimeout(resolve, delayTime));

const retry = (requestFn, userOptions = defaultOptions) => {
  const options = createOptions(userOptions);
  const { onRetry, shouldRetry } = options;
  const promise = requestFn();

  return promise.catch(err => {
    if (shouldRetryByExecutedTimes(options) && (!shouldRetry || shouldRetry(err))) {
      const optionsForNextRetry = createOptionsForNextRetry(options);
      return delay(optionsForNextRetry.currentDelay).then(() => {
        if (onRetry) onRetry(err, { ...options });
        return retry(requestFn, optionsForNextRetry);
      });
    }
    AjaxUtil.genericSendPost(
      ApiEndPoints.ClientLogs,
      JSON.stringify({ message: err?.message, url: window.location.href, fn: requestFn?.name, scope: 'cyfront-retry' })
    );
  });
};

export default retry;
